import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import CustomerColumn from './customer-column';
import InvoicingColumn from './invoicing-column';
import InvoiceActivityStatus from '../invoice-activity-status/invoice-activity-status';
import ShowMore from '../show-more/show-more-invoice';
import Ellipsis from '../svg/ellipsis';

export class InvoiceDetailsInvoicing extends React.Component {

  static propTypes = {
    description: PropTypes.string,
    title: PropTypes.string,
    invoice: PropTypes.object,
    user: PropTypes.object,
    isReviewModal: PropTypes.bool
  };

  constructor (props) {
    super(props);

    this.state = {
      showMoreList: {
        show: false
      }
    };

    this.description = this.description.bind(this);
    this.title = this.title.bind(this);
    this.toggleShowMoreList = this.toggleShowMoreList.bind(this);
    this.resetShowMoreList = this.resetShowMoreList.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.renderShowMore = this.renderShowMore.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.renderActivityStatus = this.renderActivityStatus.bind(this);
    this.showShowMoreButton = this.showShowMoreButton.bind(this);
  }

  componentDidMount () {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount () {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setWrapperRef (node) {
    this.wrapperRef = node;
  }

  description () {
    return this.props.description
      ? <Translate
        className='invoice-details-title-description large'
        content={this.props.description}
      />
      : null;
  }

  title () {
    return this.props.title
      ? <Translate
        className='invoice-details-title large'
        content={this.props.title}
      />
      : <Translate
        className='invoice-details-title large'
        content={'INVOICE_DETAILS_ORDER_NUMBER'}
        ordernumber={this.props.title ? null : this.props.invoice.id}
      />;
  }

  toggleShowMoreList () {
    this.setState({
      showMoreList: {
        show: !this.state.showMoreList.show
      }
    });
  };

  resetShowMoreList () {
    this.setState({
      showMoreList: {
        invoiceId: null,
        show: false
      }
    });
  }

  handleClickOutside (event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.resetShowMoreList();
    }
  }

  showShowMoreButton () {
    return !this.props.isReviewModal &&
      this.props.invoice.approvalStatus === 1 &&
      this.props.invoice.pdfLink;
  }

  renderShowMoreButton () {
    if (this.showShowMoreButton()) {
      return (<div
        ref={this.setWrapperRef}
        className='invoice-details-more'
        onClick={this.toggleShowMoreList}
      >
        {this.renderShowMore()}
        <Ellipsis
          colorSchema='primary'
          fill={this.state.showMoreList.show}
        />
      </div>);
    }
    return null;
  }

  renderShowMore () {
    if (this.state.showMoreList.show) {
      return <ShowMore
        invoice={this.props.invoice}
        user={this.props.user}
      />;
    }
  }

  renderActivityStatus (invoice, user) {
    return !this.props.isReviewModal
      ? (<div className='invoice-view-activity-status-container'>
        <div className='invoice-details-title'>
          <Translate content='INVOICE_STATUS' />
        </div>
        <InvoiceActivityStatus
          invoice={invoice}
          user={user}
        />
      </div>)
      : null;
  }

  render () {
    let invoice = this.props.invoice;
    let user = this.props.user;
    if (invoice && user) {
      return (<div className='invoice-details-part-container'>
        {this.title()}
        {this.description()}
        <div className={'invoice-details-wrapper' + (this.showShowMoreButton() ? '' : ' pt-20')}>
          {this.renderShowMoreButton()}
          <div className='invoice-details-row-container'>
            <CustomerColumn
              showMoreIsVisible={this.showShowMoreButton()}
              invoice={invoice}
            />
            <div className='invoice-details-column-divider'></div>
            <InvoicingColumn
              showMoreIsVisible={this.showShowMoreButton()}
              invoice={invoice}
            />
          </div>
          {this.renderActivityStatus(invoice, user)}
        </div>
      </div>);
    }
    return null;
  }
}

export default InvoiceDetailsInvoicing;



/** WEBPACK FOOTER **
 ** ./src/components/invoice-details/invoicing.js
 **/